import React, { createRef, useEffect } from 'react';
import classNames from 'classnames';

const EpiserverFormsBlock = (props) => {
  const EPiForms = createRef(null);

  function handleFocus(e, className) {
    const node = e.currentTarget;
    node.parentNode.className = classNames({
      [`${className}`]: true,
      [`${className}--is-multiple`]: node.hasAttribute('multiple'),
      [`${className}--has-focus`]: true,
    });
  }

  function handleBlur(e, className) {
    const node = e.currentTarget;
    node.parentNode.className = classNames({
      [`${className}`]: true,
      [`${className}--is-multiple`]: node.hasAttribute('multiple'),
      [`${className}--has-focus`]: false,
    });
  }

  function handleSubmit() {
    if (!EPiForms.current || !props.onSubmit) return;
    const form = EPiForms.current.querySelector('form');
    if (form) {
      form.addEventListener('submit', props.onSubmit);
    }
  }

  function wrapSelectElement() {
    if (EPiForms.current === null) return null;

    const select = EPiForms.current.querySelectorAll('select');

    if (select.length === 0) return;

    for (var i = 0; select.length - i; i++) {
      const parent = select[i].parentNode;
      const previousSibling = select[i].previousSibling;

      const wrapper = document.createElement('div');
      wrapper.className = classNames({
        'c-forms__select': true,
        'c-forms__select--is-multiple': select[i].hasAttribute('multiple'),
      });
      wrapper.appendChild(select[i]);
      parent.insertBefore(wrapper, previousSibling.nextSibling);

      select[i].onfocus = (e) => handleFocus(e, 'c-forms__select');
      select[i].onblur = (e) => handleBlur(e, 'c-forms__select');
    }
  }

  function wrapTextareaElement() {
    if (EPiForms.current === null) return null;

    const textarea = EPiForms.current.querySelectorAll('textarea');

    if (textarea.length === 0) return;

    for (var i = 0; textarea.length - i; i++) {
      const parent = textarea[i].parentNode;
      const previousSibling = textarea[i].previousSibling;

      const wrapper = document.createElement('div');
      wrapper.className = classNames({
        'c-forms__textarea': true,
      });

      wrapper.onclick = (function (elm) {
        return () => elm.focus();
      })(textarea[i]);

      wrapper.appendChild(textarea[i]);
      parent.insertBefore(wrapper, previousSibling.nextSibling);

      textarea[i].onfocus = (e) => handleFocus(e, 'c-forms__textarea');
      textarea[i].onblur = (e) => handleBlur(e, 'c-forms__textarea');
    }
  }

  function wrapChoicesElement() {
    if (EPiForms.current === null) return null;

    const choices = EPiForms.current.querySelectorAll(
      '.FormChoice__Input--Radio, .FormChoice__Input--Checkbox'
    );
    if (choices.length === 0) return;

    for (var i = 0; choices.length - i; i++) {
      const fakeInput = document.createElement('span');
      const parent = choices[i].parentNode;
      parent.insertBefore(fakeInput, choices[i].nextSibling);
      choices[i].onfocus = (e) => handleFocus(e, 'c-forms__checkbox');
      choices[i].onblur = (e) => handleBlur(e, 'c-forms__checkbox');
    }
  }

  // TODO: should run before render.
  function addSubscriptionClassToForm() {
    if (EPiForms.current === null) return null;
    const forms = EPiForms.current.querySelector('form');

    props.MailingListName ? forms.classList.add('subscription') : null;
  }

  // Re-enable, load and execute a script from the array of scripts, starting
  // at the provided index waiting on the 'onload' event before continuing with
  // the next script.
  function reEnableScriptsInOrderStartingAt(scriptIndex, scripts) {
    if (scriptIndex === scripts.length) {
      return;
    }

    const script = scripts[scriptIndex];
    script.remove();
    script.type = 'text/javascript';
    script.removeAttribute('data-pwtforms-script');
    script.onload = () =>
      reEnableScriptsInOrderStartingAt(scriptIndex + 1, scripts);
    document.body.appendChild(script);
  }

  // Because of the risk of out-of-order execution, it won't work with a simple for-loop
  // to re-enable and load the scripts.
  function reEnableScriptsInOrder(scripts) {
    reEnableScriptsInOrderStartingAt(0, scripts);
  }

  function reEnableFormsScripts() {
    if (typeof window === 'undefined') {
      return;
    }

    const episerverFooterScripts = document.querySelectorAll(
      'script[data-pwtforms-script]'
    );
    if (!episerverFooterScripts) {
      return;
    }

    reEnableScriptsInOrder(episerverFooterScripts);
  }
  useEffect(() => {
    reEnableFormsScripts();
    wrapSelectElement();
    wrapChoicesElement();
    wrapTextareaElement();
    addSubscriptionClassToForm();
    handleSubmit();
  }, []);

  return (
    <div
      ref={EPiForms}
      className="c-forms"
      dangerouslySetInnerHTML={{ __html: decodeURIComponent(props.View) }}
    ></div>
  );
};

export default EpiserverFormsBlock;
